import './ComparisonFooter.css';const comparisonFooter__row = "_comparisonFooter__row_fl172_1";
const styles = {
  comparisonFooter__row
};
export {
  comparisonFooter__row,
  styles as default
};
